import http from "./$axios";

class Api {
  //{optional} requireAuth should be true for any route that requires authorization
  static async get(url) {
    try {
      let response = await http.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async post(url, payload) {
    try {
      let response = await http.post(url, payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async put(url, payload = {}) {
    try {
      let response = await http.put(url, payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async delete(url, payload = {}) {
    try {
      let config = {
        data: payload
      };
      let response = await http.delete(url, config);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default Api;
